import { useTagValue } from "@/services/budget/setTags";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { SelectField } from "./helper";
import styles from "./budgets.module.css";
import closeCross from "@/assets/img/closecross.svg";

import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import {
  useDimensionValue,
  useDimensionkey,
} from "@/services/budget/getDimensions";
import { BudgetContext, useBudgetContext } from "../budget.context";
import { useTagsValue } from "@/services/budget/getTags.repo";
import addsymbol from "@/assets/img/addFilterBlue.svg";
import edit from "@/assets/img/budgetEditIcon.svg";
import clsx from "clsx";

const BudgetFilterComponent = ({
  editData,
  setValue,
  service,
  control,
  selectedTagValues,
  setSelectedTagValues,
  selectedValues,
  setSelectedValues,
  setTempSelectValues,
  tempSelectValues,
  setExtractData,
  rules,
  clearFilterData,
  resetField,
}) => {
  const [selectedKey, setSelectedKey] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [multiselect, setMultiselect] = useState("");
  const [disableSelectedValues, setDisableSelectedValues] = useState(false);
  const [selectedDimension, setSelectedDimension] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [showBadgeContainer, setShowBadgeContainer] = useState(false);


  const context = useContext(BudgetContext);

  const SelectedTagsLength = Object.keys(selectedTagValues).length

  useEffect(() => {
    context?.setTempSelectTagValues([]);
  }, [selectedTag]); 


  useEffect(() => {
    setTempSelectValues([]);
    context?.setTempSelectTagValues([]);
  }, [context?.SelectedManagement, context?.SelectedAccounts]);

  const subscriptionString = editData?.budgetDetails?.subscription;
  const subscriptionFilter = {
    name: "SubscriptionName",
    values: subscriptionString?.split(",").map((item) => item.split(":")[1]),
  };

  useEffect(() => {
    if (editData?.filters) {
      const dimensionValues =
        editData.filters.dimensions?.flatMap((dimension) => dimension.name) ||
        [];
      const tagValues = editData.filters.tags?.flatMap((tag) => tag.name) || [];

      setSelectedDimension(dimensionValues);
      setSelectedTag(tagValues);
      context?.setSelectedAccounts(
        editData?.budgetDetails?.managementGroupId ||
          editData?.budgetDetails?.accountId ||
          editData?.budgetDetails?.AccountId||
          editData?.budgetDetails?.account_id
      );
    }
  }, [editData]);

  const filterKeys = useMemo(() => {
    const scope =
    service==="gcp"? editData?editData?.budgetDetails?.scope:context?.selectedGroupAws:
      service === "aws" ?editData?editData?.budgetDetails?.scope:
         context?.selectedGroupAws
        : service === "azure"
        ? editData
          ? context?.selectedGroup
          : context?.selectedGroupForm
        : "";
    return {
      scope,
      service,
      selectedKey: selectedKey,
      account: context?.SelectedAccounts || context?.SelectedManagement,
      tags: multiselect,
    };
  }, [
    context?.SelectedAccounts,
    context?.SelectedManagement,
    context?.selectedGroupAws,
  ]);

  const filterKeyTagsValue = useMemo(() => {
    const scope =
    service==="gcp"?editData?editData?.budgetDetails?.scope:context?.selectedGroupAws:
      service === "aws"
        ? context?.selectedGroupAws
        : service === "azure"
        ? editData
          ? context?.selectedGroup
          : context?.selectedGroupForm
        : "";
    return {
      scope,
      service,
      selectedKey: selectedKey,
      account: context?.SelectedAccounts || context?.SelectedManagement,
      tags: multiselect,
    };
  }, [
    service,
    selectedKey,
    multiselect,
    context?.SelectedAccounts,
    context?.selectedGroupAws,
  ]);

  const filterTagKeys = useMemo(() => {
    const scope =
    service==="gcp"?editData?editData?.budgetDetails?.scope:context?.selectedGroupAws:
      service === "aws"
        ? context?.selectedGroupAws
        : service === "azure"
        ? editData
          ? context?.selectedGroup
          : context?.selectedGroupForm
        : "";
    return {
      scope,
      service,
      selectedKey: "tags",
      account: context?.SelectedManagement || context?.SelectedAccounts,
      tags: multiselect,
    };
  }, [
    context?.SelectedAccounts,
    context?.SelectedManagement,
    context?.selectedGroupAws,
  ]);

  const tagKeys = useMemo(() => {
    const scope =
    service==="gcp"?editData?editData?.budgetDetails?.scope:context?.selectedGroupAws:
      service === "aws"
        ? context?.selectedGroupAws
        : service === "azure"
        ? editData
          ? context?.selectedGroup
          : context?.selectedGroupForm
        : "";
    return {
      scope,
      service,
      tags: multiselect,
      account: context?.SelectedAccounts || context?.SelectedManagement,
    };
  }, [
    service,
    multiselect,
    context?.SelectedAccounts,
    context?.SelectedManagement,
    context?.selectedGroupAws,
  ]);

  let { data: dimensionTag, isLoading: dimensionTagLoading } =
    useDimensionkey(filterKeys);

  const validata = [
    "tags",
    "Service",
    "LinkedAccount",
    "Region",
    "InstanceType",
    "UsageType",
    "MeterCategory",
    "MeterName",
    "ResourceGroupName",
    "SubscriptionName",
    "service"
  ];
  // let {
  //   data: dimensionValue,
  //   isLoading: dimensionValueLoading,
  //   refetch,
  // } = useDimensionValue(filterKeyTagsValue, validata.includes(selectedKey));
  let {
  data: dimensionValue,
  isLoading: dimensionValueLoading,
  refetch,
} = useDimensionValue(
  filterKeyTagsValue,
  validata.includes(selectedKey),
  {
    enabled: Boolean(selectedKey && validata.includes(selectedKey)),
  }
);

// console.log("selectedKey",selectedKey,"filterKeyTagsValue",filterKeyTagsValue)
  const hasSelectedContext = !!(
    context?.SelectedAccounts || context?.SelectedManagement
  );

  let { data: tagsKeysValues, isLoading: tagsKeysValuesLoading } = useTagsValue(
    filterTagKeys,
    hasSelectedContext
  );

  let { data: tagValues, isLoading: tagValuesLoading } = useTagValue(tagKeys);

  const dimensionValueDEW = (editData?.filters?.dimensions || []).map((i) => ({
    id: i.name,
    name: i.name,
  }));
  const tagsValueDEW = (editData?.filters?.tags || []).map((i) => ({
    id: i.name,
    name: i.name,
  }));

  const filteredDimensionValues = editData?.filters?.dimensions
    ?.filter((dim) => dim.name === selectedDimension)
    ?.flatMap((dim) => dim.values)
    .map((value) => ({
      id: value,
      name: value,
    }));

  const filteredTagValues = editData?.filters?.tags
    ?.filter((dim) => dim.name === selectedTag)
    ?.flatMap((dim) => dim.values)
    .map((value) => ({
      id: value,
      name: value,
    }));

  const dimension = dimensionTag?.filter((e) => e.id !== "tags").map((e) => e);

  const handleSelectedkeys = (selected) => {
    setSelectedValue(selected);
    setSelectedKey(selected);
    setSelectedDimension(selected);
    if (selected) {
      let newData =
        (dimension || []).find((item) => item.id === selected) || {};
      setSelectedKey(selected);
      setExtractData((prevSelectedNames) => [...prevSelectedNames, newData]);
    }
  };

  const handleValues = (values) => {
    setSelectedTag(values);
    setMultiselect(values);
    setSelectedValue(values);
  };

  const handleBadgeRemoval = useCallback(
    (filterName, badgeIndex) => {
      setSelectedValues((prevValues) => {
        const updatedValues = { ...prevValues };

        const removeValues = updatedValues[filterName] || [];
        if (filterName !== "Tag Values") {
          delete updatedValues[filterName];

          updatedValues["Dimension Values"] = updatedValues[
            "Dimension Values"
          ].filter((dim) => !removeValues.includes(dim.id));
        }

        setSelectedValues(updatedValues);

        return updatedValues;
      });
    },
    [setSelectedValues]
  );

  const handleBadgeRemovalTags = useCallback(
    (filterName) => {
      if (service === "gcp") {
        setSelectedTagValues([]);
        setSelectedTag({})
      } else {
  
      setSelectedTagValues((prevValues) => {
        const updatedValues = { ...prevValues };
        const removetagValues = updatedValues[filterName] || [];
        if (filterName !== "Dimension Values") {
          delete updatedValues[filterName];

          if (Array.isArray(updatedValues["Tag Values"])) {
            updatedValues["Tag Values"] = updatedValues["Tag Values"].filter(
              (dim) => !removetagValues.some((rm) => rm.id === dim.id)
            );
          }
        }
  
        return updatedValues;
      })
    }
    },
    [setSelectedTagValues]
  );
  

  // useEffect(() => {
  //   const initialSelectedValues = {
  //     "Dimension Values": [],
  //   };
  //   const initialSelectedTagValues = {
  //     "Tag Values": [],
  //   };

  //   if (editData) {
  //     (editData?.filters?.dimensions || []).forEach((dimension) => {
  //       initialSelectedValues[dimension.name] = dimension.values.map(
  //         (value) => ({
  //           id: value,
  //           name: value,
  //         })
  //       );
  //       const formattedDimensionValues = dimension.values.map((value) => ({
  //         id: value,
  //         name: value,
  //       }));
  //       initialSelectedValues["Dimension Values"].push(
  //         ...formattedDimensionValues
  //       );
  //     });
  //     (editData?.filters?.tags || []).forEach((tag) => {
  //       initialSelectedTagValues[tag.name] = tag.values.map((value) => ({
  //         id: value,
  //         name: value,
  //       }));
  //       const formattedTagValues = tag.values.map((value) => ({
  //         id: value,
  //         name: value,
  //       }));
  //       initialSelectedTagValues["Tag Values"].push(...formattedTagValues);
  //     });
  //     setSelectedValues(initialSelectedValues);
  //     setSelectedTagValues(initialSelectedTagValues);
  //   }
  // }, [editData]);

    useEffect(() => {
    if (selectedDimension) {
      context?.setSelectDimensionKeys(selectedDimension);
    }
  }, [selectedDimension]);
  
  console.log("selectedDimension",selectedDimension)

  console.log("context?.selectDimesnionKeys",context?.selectDimesnionKeys)

const isAwsAccount =
    service === "aws" && context?.selectDimesnionKeys?.includes("Account");
 
  const isAzureSubscription =
    service === "azure" &&
    context?.selectDimesnionKeys?.includes("SubscriptionName");
  const isGcpSubscription =
    service === "gcp" &&
    context?.selectDimesnionKeys?.includes("service");

  useEffect(() => {
    if (isAwsAccount) {
      setSelectedKey("account");
      refetch();
    } else if (isAzureSubscription) {
      setSelectedKey("SubscriptionName");
      refetch();
    } else if (isGcpSubscription) {
      setSelectedKey("service");
      refetch();
    }
  }, [isAwsAccount, isAzureSubscription, isGcpSubscription, refetch]);

  useEffect(() => {
    refetch()
    if ((isAwsAccount || isAzureSubscription ||isGcpSubscription) && dimensionValue?.data?.length) {
      context?.setDimensionValueData(dimensionValue.data);
    }
  }, [isAwsAccount, dimensionValue, context, isAzureSubscription,isGcpSubscription, refetch]);

  useEffect(() => {
    const initialSelectedValues = {
      "Dimension Values": [],
    };
    const initialSelectedTagValues = {
      "Tag Values": [],
    };

    if (editData) {
      (editData?.filters?.dimensions || []).forEach((dimension) => {
        const formattedValues = dimension.values.map((value) => {
        // If AWS Account → match ID with API response
        if (
          (isAwsAccount || isAzureSubscription || isGcpSubscription) &&
          context?.dimensionValueData?.length
        ) {
          const matched = context.dimensionValueData.find(
            (item) => item.id === value
          );
          return matched
            ? { id: matched.id, name: matched.name } // ✅ show name
            : { id: value, name: value }; // fallback = ID
        }
 
        // Non-AWS → just return value
        return { id: value, name: value };
      });
 
      initialSelectedValues[dimension.name] = formattedValues;
      initialSelectedValues["Dimension Values"].push(...formattedValues);
    });

    context?.setSelectedValues(initialSelectedValues);
 
      
      // const subscriptionMap = {};
      // const subscriptionString = editData?.budgetDetails?.subscription || "";
      // subscriptionString.split(",").forEach((entry) => {
      //   const [id, name] = entry.split(":");
      //   subscriptionMap[id] = name;
      // });

      // (editData?.filters?.dimensions || []).forEach((dimension) => {
      //   let formattedValues;

      //   if (dimension.name === "SubscriptionName") {
      //     formattedValues = dimension.values.map((id) => ({
      //       id,
      //       name: subscriptionMap[id] || id,
      //     }));
      //   } else {
      //     formattedValues = dimension.values.map((value) => ({
      //       id: value,
      //       name: value,
      //     }));
      //   }

      //   initialSelectedValues[dimension.name] = formattedValues;
      //   initialSelectedValues["Dimension Values"].push(...formattedValues);
      // });

      // Handle tags
      (editData?.filters?.tags || []).forEach((tag) => {
        const formattedTagValues = tag.values.map((value) => ({
          id: value,
          name: value,
        }));
        initialSelectedTagValues[tag.name] = formattedTagValues;
        initialSelectedTagValues["Tag Values"].push(...formattedTagValues);
      });

      // setSelectedValues(initialSelectedValues);
      setSelectedTagValues(initialSelectedTagValues);
    }
  }, [editData, context?.dimensionValueData,isAwsAccount, isAzureSubscription,isGcpSubscription]);

  useEffect(() => {
    if (context?.SelectedAccounts?.length && resetField) {
      resetField("Dimension");
      resetField("resource_group");
      resetField("Tags");
      clearFilterData();
      setSelectedKey("");
      setMultiselect("");
      setSelectedValue("");
    }
  }, [context?.SelectedAccounts]);
  useEffect(() => {
    if (context?.SelectedManagement?.length && resetField) {
      resetField("Dimension");
      resetField("resource_group");
      resetField("Tags");
      clearFilterData();
      setSelectedKey("");
      setMultiselect("");
      setSelectedValue("");
    }
  }, [context?.SelectedManagement]);

  const handleAddFilterClick = () => {
    setShowBadgeContainer(true);
    setValue("Dimension", undefined);
    setSelectedValues((prevValues) => {
      const mergedValues = { ...prevValues };
      Object.keys(tempSelectValues).forEach((key) => {
        if (mergedValues[key]) {
          mergedValues[key] = [
            ...mergedValues[key],
            ...tempSelectValues[key].filter(
              (item) => !mergedValues[key].some((v) => v.id === item.id)
            ),
          ];
        } else {
          mergedValues[key] = [...tempSelectValues[key]];
        }
      });

      return mergedValues;
    });

    setSelectedDimension("");
    setTempSelectValues([]);
    setSelectedValue("");
    setSelectedKey("");
  };

  const handleAddTagsFilter = () => {
    setShowBadgeContainer(true);
    setValue("Tags", undefined);
    setSelectedTagValues((prevValues) => {
      const mergedValues = { ...prevValues };
      Object.keys(context?.tempSelectTagValues).forEach((key) => {
        if (mergedValues[key]) {
          mergedValues[key] = [
            ...mergedValues[key],
            ...context?.tempSelectTagValues[key].filter(
              (item) => !mergedValues[key].some((v) => v.id === item.id)
            ),
          ];
        } else {
          mergedValues[key] = [...context?.tempSelectTagValues[key]];
        }
      });

      return mergedValues;
    });
    context?.setTempSelectTagValues([]);
    setSelectedTag("")
    setMultiselect("")
  };

  const handleEditClick = (filterName) => {
    setValue("Dimension", filterName);
    setValue("Tags", filterName);
    setTempSelectValues({ [filterName]: selectedValues[filterName] });
    setSelectedDimension(filterName);
    setSelectedValue(filterName);
    setSelectedKey(filterName);
  };

  // useEffect(() => {
  //   const hasValues = Object.keys(selectedValues).some((key) => {
  //     return (
  //       Array.isArray(selectedValues[key]) && selectedValues[key].length > 0
  //     );
  //   });
  //   setShowBadgeContainer(hasValues);
  // }, [selectedValues]);

  useEffect(() => {
    const hasValues =
      Object.keys(selectedValues).some(
        (key) =>
          Array.isArray(selectedValues[key]) && selectedValues[key].length > 0
      ) ||
      Object.keys(selectedTagValues).some(
        (key) =>
          Array.isArray(selectedTagValues[key]) &&
          selectedTagValues[key].length > 0
      );

    setShowBadgeContainer(hasValues);
  }, [selectedValues, selectedTagValues]);

  const handleGetDimensionValues = (selectedDimension) => {
    setSelectedKey(selectedDimension);
    setMultiselect(selectedDimension);
    // refetch();
  };

  const handleFilterClick = (fieldName) => {
    setSelectedKey(fieldName);
    setMultiselect(fieldName);
    // refetch();
  };

  const filteredDimension = useMemo(() => {
    const listToHide = Object.keys(selectedValues).filter(
      (e) => e !== "Dimension Values" && e !== "Tag Values"
    );

    return (dimension || []).filter((item) => !listToHide.includes(item.id));
  }, [selectedValues, dimension]);

  const filteredTags = useMemo(() => {
    const listToHide = Object.keys(selectedTagValues).filter(
      (e) => e !== "Dimension Values" && e !== "Tag Values"
    );

    return (tagsKeysValues?.data || []).filter(
      (item) => !listToHide.includes(item.name)
    );
  }, [selectedTagValues, tagsKeysValues?.data]);

  return (
    <>
      <div className={styles.budgetsFilterSection}>
        <div className={styles.filterDimension}>
          <div>
            <p className={styles.filterHeading}>Filter</p>
            <p className={styles.filterTagLine}>
              Select Your Dimensions & Tags and Enhance Budget Precision
            </p>
          </div>
          <div
            className="charge_select"
            style={{ justifyContent: "flex-start" }}
          >
            <SelectField
              control={control}
              title={"Dimension"}
              placeholder={"Select Dimension"}
              fieldName="Dimension"
              rules={rules?.Dimension?.message}
              azureFieldData={filteredDimension}
              commonFieldData={filteredDimension}
              service={service}
              onSelect={handleSelectedkeys}
              isLoading={dimensionTagLoading}
              CustomWidth={true}
            />
            <span className={styles.semicolon}>:</span>
            <div style={{ paddingTop: "10px" }}>
              <div className="accountid_box">
                <div
                  id="filterComp"
                  className="input_box_css"
                  style={{ padding: 0, width: "270px" }}
                  onClick={() => handleGetDimensionValues(selectedDimension)}
                >
                  <MultiselectFilter
                    data={dimensionValue?.data}
                    filterName={dimensionValue?.filter || selectedDimension}
                    filterType="Dimension Values"
                    selectedValues={tempSelectValues}
                    azureFieldData={(dimension || []).map((item) => item)}
                    setSelectedValues={setTempSelectValues}
                    disableSelectedValues={disableSelectedValues}
                    setDisableSelectedValues={setDisableSelectedValues}
                    selectedVAlue={selectedValue}
                    isLoading={dimensionValueLoading}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.fill_add_symbol}
              onClick={handleAddFilterClick}
            >
              <img src={addsymbol} alt="Add"></img>{" "}
              <span className={styles.add_filter_name}>Add Filter</span>
            </div>
          </div>
          {showBadgeContainer && (
            <BadgeContainer
              showEditIcon={true}
              selectedValues={selectedValues}
              handleEditClick={handleEditClick}
              handleBadgeRemoval={handleBadgeRemoval}
              setSelectedValues={setSelectedValues}
              dimensionValue={dimensionValue?.data}
              dimension={dimension}
              title="Dimension"
              selectedVAlue={selectedValue}
              handleFilterClick={handleFilterClick}
              isLoading={dimensionValueLoading}
              disableSelectedValues={disableSelectedValues}
              setDisableSelectedValues={setDisableSelectedValues}
            />
          )}
        </div>
        <div className={styles.filterDimension}>
          <div className="charge_select">
            <SelectField
              control={control}
              title={"Tags"}
              placeholder={"Select a tag"}
              fieldName="Tags"
              azureFieldData={filteredTags}
              commonFieldData={filteredTags}
              rules={rules?.Tags?.message}
              service={service}
              onSelect={handleValues}
              isLoading={tagsKeysValuesLoading}
              search="search"
              CustomWidth={true}
              disableOption={service==="gcp" && SelectedTagsLength >=2 ? true :false}
            />

            <span className={styles.semicolon}>:</span>
            <div style={{ paddingTop: "10px" }}>
              <div className="accountid_box">
                <div
                  id="filterComp"
                  className="input_box_css"
                  style={{ padding: 0, width: "270px" }}
                  onClick={() => handleGetDimensionValues(selectedTag)}
                >
                  <MultiselectFilter
                  service= {service}
                    data={tagValues?.data}
                    filterType="Tag Values"
                    filterName={tagValues?.filter || selectedTag}
                    selectedValues={context?.tempSelectTagValues}
                    azureFieldData={(tagsKeysValues?.data || []).map(
                      (item) => item
                    )}
                    setSelectedValues={context?.setTempSelectTagValues}
                    disableSelectedValues={disableSelectedValues}
                    setDisableSelectedValues={setDisableSelectedValues}
                    selectedVAlue={multiselect}
                    isLoading={tagValuesLoading}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.fill_add_symbol}
              onClick={handleAddTagsFilter}
            >
              <img src={addsymbol} alt="Add"></img>{" "}
              <span className={styles.add_filter_name}>Add Tag</span>
            </div>
          </div>

          {showBadgeContainer && (
            <BadgeContainer
            service={service}
              selectedValues={selectedTagValues}
              handleBadgeRemoval={handleBadgeRemovalTags}
              dimension={tagsKeysValues?.data}
              setSelectedValues={setSelectedTagValues}
              title="Tag"
              dimensionValue={tagValues?.data}
              selectedVAlue={multiselect}
              handleFilterClick={handleFilterClick}
              isLoading={tagValuesLoading}
              disableSelectedValues={disableSelectedValues}
              setDisableSelectedValues={setDisableSelectedValues}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default BudgetFilterComponent;

const MultiselectFilter = ({
  service,
  isLoading,
  data,
  filterType,
  selectedValues,
  setSelectedValues,
  filterName,
  azureFieldData,
  disableSelectedValues,
  setDisableSelectedValues,
  selectedVAlue,
}) => {
  let Options = (data || []).map((e) => {
    return {
      id: e.id,
      name: e.name,
    };
  });


  // const handleSelect = useCallback(
  //   (selectedList) => {
  //     setSelectedValues((prevValues) => {
  //       let newValues = [];
  //       azureFieldData.forEach((e) => {
  //         if (e.id === filterName) {

  //           const segregatedValues = Options.filter((options) =>
  //             (service === "gcp" ?[selectedList]:selectedList || []).map((v) => v.id).includes(options.id)
  //           );
  //           newValues = [
  //             ...newValues,
  //             ...segregatedValues.map((option) => ({
  //               id: option.id,
  //               name: option.name,
  //             })),
  //           ];
  //         }
  //       });

  //       return {
  //         ...prevValues,
  //         [filterName]: newValues,
  //         [filterType]: [
  //           ...(selectedValues[filterType] || []),
  //           ...selectedList,
  //         ],
  //       };
  //     });
  //   },
  //   [
  //     Options,
  //     azureFieldData,
  //     filterName,
  //     filterType,
  //     selectedValues,
  //     setSelectedValues,
  //   ]
  // );
  const handleSelect = useCallback(
    (selectedList) => {
  
      setSelectedValues((prevValues) => {
        let newValues = [];
  
        // Normalize selectedList to always be an array of objects with ids
        const normalizedList = service === "gcp"
          ? selectedList
            ? [selectedList]
            : []
          : selectedList || [];
  
        const selectedIds = normalizedList.map((v) => v.id);
  
        azureFieldData.forEach((e) => {
          if (e.id === filterName) {
            const segregatedValues = Options.filter((option) =>
              selectedIds.includes(option.id)
            );
  
            newValues = [
              ...newValues,
              ...segregatedValues.map((option) => ({
                id: option.id,
                name: option.name,
              })),
            ];
          }
        });
  
        return {
          ...prevValues,
          [filterName]: newValues,
          [filterType]: [
            ...(selectedValues[filterType] || []),
            ...normalizedList,
          ],
        };
      });
    },
    [
      Options,
      azureFieldData,
      filterName,
      filterType,
      selectedValues,
      service,
      setSelectedValues,
    ]
  );

  React.useEffect(() => {
    if (disableSelectedValues) {
      setSelectedValues((prevValues) => {
        const updatedValues = { ...prevValues };
        updatedValues[filterName] = { values: [] };
        updatedValues[filterType] = [];
        return updatedValues;
      });
      setDisableSelectedValues(false);
    }
  }, [
    disableSelectedValues,
    filterName,
    filterType,
    setDisableSelectedValues,
    setSelectedValues,
  ]);

  const formattedPlaceholder = useMemo(() => {
    const filterSelectedValues = selectedValues[filterName] || [];
    if (filterSelectedValues?.length > 0) {
      const firstValue = filterSelectedValues[0]?.name || "null";
      const additionalCount =
        filterSelectedValues?.length > 1
          ? ` +${filterSelectedValues?.length - 1}`
          : "";
      return `${firstValue}${additionalCount}`;
    }
    return "Select";
  }, [selectedValues, filterName]);

  return (
    <FilterSearch
      disabled={selectedVAlue?.length <= 0}
      loading={isLoading}
      multiselect={service !== "gcp"?true:false}
      options={Options}
      selectedValues={selectedValues[filterName] || []}
      onSelect={(list) => {
        handleSelect(list);
      }}
      onRemove={(list) => {
        handleSelect(list);
      }}
      displayValue="name"
      placeholder={"select the Dimension"}
      toggle={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              paddingLeft: "4px",
            }}
          >
            {selectedValues[filterName]?.length > 0 ? (
              <span
                className={styles.toggle_value}
                title={formattedPlaceholder.split("+")[0]}
                style={{
                  textOverflow: "ellipsis",
                  textWrap: "nowrap",
                  maxWidth: "180px",
                  overflow: "hidden",
                }}
              >
                {formattedPlaceholder.split("+")[0]}
              </span>
            ) : (
              <span className={styles.placeholderFilter}>Select</span>
            )}

            {(selectedValues[filterName]?.length || 0) > 1 && (
              <span className={styles.toggle_value}>
                +{selectedValues[filterName]?.length - 1}
              </span>
            )}
          </div>
        </>
      }
    />
  );
};

const BadgeContainer = ({
  service,
  selectedValues,
  handleBadgeRemoval,
  setSelectedValues,
  dimension,
  dimensionValue,
  title,
  handleFilterClick,
  setDisableSelectedValues,
  disableSelectedValues,
  isLoading,
}) => {
  return (
    <>
      {Object.keys(selectedValues)
        .filter((e) => e !== "Dimension Values" && e !== "Tag Values")
        .map((filterName, index) => (
          <>
            {selectedValues[filterName] && (
              <div className={styles.filter_dimension}>
                <span className={styles.dimensio_name}>{title}</span>
                <div className={styles.filter_box}>
                  <span
                    className={clsx("input_box_css", styles.filternamed)}
                    style={{ width: "270px" }}
                  >
                    {filterName}
                  </span>

                  <span
                    className={styles.semicolon}
                    style={{ marginTop: "4px" }}
                  >
                    :
                  </span>
                  <span className={styles.badgesValues}>
                    <div
                      id="filterComp"
                      className="input_box_css"
                      style={{ padding: 0, width: "270px" }}
                      onClick={() => handleFilterClick(filterName)}
                    >
                      <MultiselectFilter
                      service={service}
                        data={dimensionValue}
                        filterName={filterName}
                        filterType="Dimension Values"
                        selectedValues={selectedValues}
                        azureFieldData={(dimension || []).map((item) => item)}
                        setSelectedValues={setSelectedValues}
                        selectedVAlue={filterName}
                        isLoading={isLoading}
                        disableSelectedValues={disableSelectedValues}
                        setDisableSelectedValues={setDisableSelectedValues}
                      />
                    </div>
                    <span
                      onClick={() => handleBadgeRemoval(filterName, index)}
                      style={{
                        cursor: "pointer",
                        padding: "0px 0px 0px 6px",
                      }}
                      className={styles.remove_button}
                    >
                      Remove
                    </span>
                  </span>
                </div>
              </div>
            )}
          </>
        ))}
    </>
  );
};
